import React from "react";
import { toggleLinksSidebar } from "../../store/actions";
import { useDispatch } from "react-redux";

const BurgerIcon = () => {
  const dispatch = useDispatch();

  return (
    <div
      onClick={() => dispatch(toggleLinksSidebar())}
      className="text-black cursor-pointer text-lg"
    >
      <i className="fas fa-bars" />
    </div>
  );
};

export default BurgerIcon;
